export default function UseWindowDimensions({
  windowDimensionConditionProp,
  setWindowDimensionCondition,
}) {
  return (
    <div>
      <div
        className={`modal customePopup ${
          windowDimensionConditionProp ? "show" : "fade"
        }`}
        style={{ display: windowDimensionConditionProp ? "block" : "none" }}
        id="alert"
        tabIndex="-1"
        aria-labelledby="alertLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered popup-sm">
          <div className="modal-content">
            <div className="modal-header">
              {/* <img className="close" src={closeIcon} alt="" data-bs-dismiss="modal" aria-label="Close" onClick={() => setWindowDimensionCondition(false)} /> */}
            </div>
            <div className="modal-body text-center position-relative">
              <h3 className="title text-uppercase"> Attention!</h3>
              <p className="card-p mb--0">
                {" "}
                This Crib Beta Event is only available on Desktop!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
